export function translateText(translate, key, fallback) {
  const value = typeof translate === "function" ? translate(key) : undefined;
  return value && value !== key ? value : fallback;
}

function normalizeText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

function replaceInsensitive(source, search, replacement) {
  const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return source.replace(new RegExp(escaped, "gi"), replacement);
}

function replaceModeSwitches(source, translate) {
  return source
    .replace(
      /Cambio en el tablero de modo\s+Manual\s+a\s+Autom[aá]tico/gi,
      translateText(
        translate,
        "history_switch_manual_to_automatic",
        "Cambio en el tablero de modo Manual a Automatico"
      )
    )
    .replace(
      /Cambio en el tablero de modo\s+manual\s+a\s+autom[aá]tico/gi,
      translateText(
        translate,
        "history_switch_manual_to_automatic",
        "Cambio en el tablero de modo Manual a Automatico"
      )
    )
    .replace(
      /Cambio en el tablero de modo\s+Autom[aá]tico\s+a\s+Manual/gi,
      translateText(
        translate,
        "history_switch_automatic_to_manual",
        "Cambio en el tablero de modo Automatico a Manual"
      )
    )
    .replace(
      /Cambio en el tablero de modo\s+autom[aá]tico\s+a\s+manual/gi,
      translateText(
        translate,
        "history_switch_automatic_to_manual",
        "Cambio en el tablero de modo Automatico a Manual"
      )
    );
}

function shouldPreferCombinedMessage(text) {
  const normalized = normalizeText(text);
  return (
    normalized.includes("cambio en el tablero de modo") ||
    normalized.includes("modificacion de umbrales de alarma") ||
    normalized.includes("modificacion de umbrales") ||
    normalized.includes("inyeccion de oxigeno")
  );
}

export function translateHistoryMessage(value, translate) {
  let text = String(value || "");
  const oxygenInjection = translateText(
    translate,
    "history_oxygen_injection",
    "inyeccion de oxigeno"
  );

  const replacements = [
    [
      "Cambio en el tablero de modo Manual a Automatico",
      translateText(
        translate,
        "history_switch_manual_to_automatic",
        "Cambio en el tablero de modo Manual a Automatico"
      ),
    ],
    [
      "Cambio en el tablero de modo Manual a Automático",
      translateText(
        translate,
        "history_switch_manual_to_automatic",
        "Cambio en el tablero de modo Manual a Automatico"
      ),
    ],
    [
      "Cambio en el tablero de modo Automatico a Manual",
      translateText(
        translate,
        "history_switch_automatic_to_manual",
        "Cambio en el tablero de modo Automatico a Manual"
      ),
    ],
    [
      "Cambio en el tablero de modo Automático a Manual",
      translateText(
        translate,
        "history_switch_automatic_to_manual",
        "Cambio en el tablero de modo Automatico a Manual"
      ),
    ],
    [
      "[SISTEMA AUTOMATICO]",
      translateText(translate, "history_automatic_system", "[SISTEMA AUTOMATICO]"),
    ],
    [
      "[SISTEMA AUTOMÁTICO]",
      translateText(translate, "history_automatic_system", "[SISTEMA AUTOMATICO]"),
    ],
    ["[USUARIO]", translateText(translate, "history_user", "[USUARIO]")],
    [
      "Encendiendo Nanoox",
      `${translateText(translate, "history_turning_on_nanoox", "Encendiendo")} ${translateText(
        translate,
        "history_nanoox",
        "Nanoox"
      )}`,
    ],
    [
      "Deteniendo Nanoox",
      `${translateText(translate, "history_turning_off_nanoox", "Deteniendo")} ${translateText(
        translate,
        "history_nanoox",
        "Nanoox"
      )}`,
    ],
    [
      "Iniciando inyeccion de oxigeno",
      `${translateText(translate, "history_starting_oxygen_injection", "Iniciando")} ${translateText(
        translate,
        "history_oxygen_injection",
        "inyeccion de oxigeno"
      )}`,
    ],
    [
      "Iniciando inyección de oxígeno",
      `${translateText(translate, "history_starting_oxygen_injection", "Iniciando")} ${translateText(
        translate,
        "history_oxygen_injection",
        "inyeccion de oxigeno"
      )}`,
    ],
    [
      "Deteniendo inyeccion de oxigeno",
      `${translateText(translate, "history_stopping_oxygen_injection", "Deteniendo")} ${translateText(
        translate,
        "history_oxygen_injection",
        "inyeccion de oxigeno"
      )}`,
    ],
    [
      "Deteniendo inyección de oxígeno",
      `${translateText(translate, "history_stopping_oxygen_injection", "Deteniendo")} ${translateText(
        translate,
        "history_oxygen_injection",
        "inyeccion de oxigeno"
      )}`,
    ],
    [
      "Modificacion de umbrales de alarma",
      translateText(
        translate,
        "history_alarm_threshold_change",
        "Modificacion de umbrales de alarma"
      ),
    ],
    [
      "Modificación de umbrales de alarma",
      translateText(
        translate,
        "history_alarm_threshold_change",
        "Modificacion de umbrales de alarma"
      ),
    ],
    [
      "inyeccion de oxigeno",
      oxygenInjection,
    ],
    [
      "inyección de oxígeno",
      oxygenInjection,
    ],
  ];

  for (const [search, replacement] of replacements) {
    text = replaceInsensitive(text, search, replacement);
  }

  text = replaceModeSwitches(text, translate);

  text = text.replace(
    /\ben jaula\b/gi,
    translateText(translate, "in_cage", "en jaula")
  );
  text = text.replace(/\bMin:/gi, `${translateText(translate, "min", "Min")}:`);
  text = text.replace(/\bMax:/gi, `${translateText(translate, "max", "Max")}:`);

  return text.trim();
}

export function formatHistoryEntry(item, translate) {
  if (typeof item === "string") {
    return {
      isStructured: false,
      message: translateHistoryMessage(item, translate),
      fecha: "",
    };
  }

  if (!item) {
    return {
      isStructured: false,
      message: "",
      fecha: "",
    };
  }

  const responsable = translateHistoryMessage(item.responsable, translate);
  const descripcion = translateHistoryMessage(item.descripcion, translate);
  const ubicacion = translateHistoryMessage(item.ubicacion, translate);
  const rawAction = normalizeText(item.accion);
  const rawDescription = normalizeText(item.descripcion);
  const combinedSource = [item.responsable, item.accion, item.descripcion, item.ubicacion]
    .filter(Boolean)
    .join(" ");

  let accion = translateHistoryMessage(item.accion, translate);

  if (rawAction === "encendiendo") {
    accion = translateText(translate, "history_turning_on_nanoox", "Encendiendo");
  } else if (rawAction === "deteniendo" && rawDescription.includes("nanoox")) {
    accion = translateText(translate, "history_turning_off_nanoox", "Deteniendo");
  } else if (rawAction === "deteniendo" && rawDescription.includes("inyeccion de oxigeno")) {
    accion = translateText(
      translate,
      "history_stopping_oxygen_injection",
      "Deteniendo"
    );
  } else if (rawAction === "iniciando" && rawDescription.includes("inyeccion de oxigeno")) {
    accion = translateText(
      translate,
      "history_starting_oxygen_injection",
      "Iniciando"
    );
  }

  return {
    isStructured: Boolean(responsable || accion || descripcion || ubicacion),
    responsable,
    accion,
    descripcion,
    ubicacion,
    fecha: item.fecha || item.hora || item.timestamp || "",
    message: translateHistoryMessage(item.msg || combinedSource, translate),
    preferCombinedMessage:
      (!accion && shouldPreferCombinedMessage(combinedSource)) ||
      shouldPreferCombinedMessage(item.msg),
  };
}

export function getHistoryTone(...values) {
  const text = normalizeText(values.filter(Boolean).join(" "));
  if (text.includes("encendiendo") || text.includes("iniciando")) {
    return "#00ff38";
  }
  if (text.includes("deteniendo")) {
    return "#ff3030";
  }
  return "#ffffff";
}
